<template>
  <div class="share">
    <ShareNetwork
        v-for="social in socials"
        :key="social.slug"
        :network="social.slug"
        :url="url"
        :title="title"
        :description="description"
        :quote="quote"
        hashtags="event,impact,makesense"
        twitter-user="makesense"
        @click.native="onClick"
      >
        <mks-icon
          :type="social.icon || social.slug"
          size="20"
          :alt="`${__('Partager via')} ${social.name}`"
        ></mks-icon>
        <p aria-label="Share on Facebook"></p>
    </ShareNetwork>
    <mks-button variant="bare" tag="button" @click="copy">
      <mks-icon type="copy" size="20"></mks-icon>
      <mks-text size="small" color="inherit" class="copy-text">{{__("Copier le lien")}}</mks-text>
    </mks-button>
  </div>
</template>
<script>
export default {
  name: "Share",
  props: {
    url: String,
    title: String,
    description: String,
    quote: String,
    hashtags: String
  },
  data() {
    return {
      socials: [
        {
          slug: "facebook",
          name: "Facebook",
        },
        {
          icon: "message-circle",
          slug: "whatsapp",
          name: "Whatsapp",
        },
        {
          slug: "twitter",
          name: "Twitter",
        },
        {
          slug: "linkedin",
          name: "Linkedin",
        },
        {
          icon: 'send',
          slug: "email",
          name: "Email",
        },
      ],
    };
  },
  methods: {
    copy() {
      this.$copyText(this.url).then(
        (e) => {
          this.$toasted.show(this.__('C\'est copié, manque plus qu\'à coller !'), {
            type: 'info',
            position: 'bottom-center',
            duration: 2000
          })
        },
        (e) => {
          this.$toasted.show(this.__('Oups, une erreur s\'est produite :('), {
            type: 'error',
            position: 'bottom-center',
            duration: 2000
          })
        }
      );

      this.$store.dispatch("analytics/track", {
        event: "Makesense Chiche - Copy share link",
        data: {
          link: this.url,
          title: this.title
        }
      });
    },
    onClick() {
      this.$store.dispatch("analytics/track", {
        event: "Makesense Chiche - Share",
        data: {
          link: this.url,
          title: this.title
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.share {
  display: inline-flex;
  background: $background-color-soft;
  align-items: center;
  // border: 1px solid $color-cerise;
  border-radius: $border-radius-full;
  @include inner-space("xs", "y");
  @include inner-space("s", "x");
  margin-left: auto;
  margin-right: auto;
  & > * + * {
    margin-left: $space-xs;
  }
  a, button, .mks-button{
    color: $color-text;
    border-bottom: none;
    &:hover{
      color: $color-tertiary !important;
      span {
        color: $color-tertiary !important;
      }
    }
  }
}
.copy-text {
    text-transform: none;
}
</style>